const isWebview = () => {
  const userAgent = navigator.userAgent;

  return (
    /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(userAgent) ||
    /(Linux;.*AppleWebKit.*Version\/\d+\.\d+.*Mobile).*/i.test(userAgent)
  );
};

export { isWebview };



// WEBPACK FOOTER //
// ./src/utils/UserAgentHelper.js